// extracted by mini-css-extract-plugin
export default {"icon":"icon__JGliTpKq","exportModalPopper":"exportModalPopper__PKRvr2zA"};